import React from "react";
import { Link } from "react-router-dom";
import "./footer.css";
import picture from "../../assets/thanos.jpg";

const Footer = () => {
  return (
    <footer id="footer">
      <div className="footer__container">
        <div className="footer__main">
          <div className="footer__title">
            <img src={picture} alt="" />
          </div>
          <div className="footer__contact">
          <a href="mailto:muhammdagungpermana@gmail.com">Send Email</a>
          </div>
        </div>
        <div className="footer__info">
          <div className="footer__section">
            <a
              target="_blank"
              rel="noreferrer noopener"
              href="https://instagram.com/agung_125_"
            >
              Instagram
            </a>
            <a
              target="_blank"
              rel="noreferrer noopener"
              href="https://github.com/1267363"
            >
              GitHub
            </a>
          </div>
          <div className="footer__section">
           <a
              target="_blank"
              rel="noreferrer noopener"
              href="https://www.tiktok.com/@cinematic_official"
            >
              TikTok
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
